export default {
  name: 'home',
  data() {
    return {
      datas: {
        username: '',
        password: ''
      },

      sigin: false,
      remind: false,
      isLogin: true
    }
  },
  created() {
    let that = this
    if (this.axios.defaults.baseURL != '') {
    }

    let loginStatus = localStorage.getItem('loginStatus')
    if (loginStatus == 1) {
      this.$router.push({ path: '/home' })
      return
    }
    document.onkeypress = function (e) {
      var keycode = document.all ? event.keyCode : e.which
      if (keycode == 13) {
        that.login()
      }
    }
  },
  mounted: function () {

  },
  methods: {
    changeSigin: function () {
      this.isLogin = false
    },
    login: function () {
      let that = this
      if (!this.datas.username) {
        this.$message('请输入账号')
        return
      }
      if (!this.datas.password) {
        this.$message('请输入密码')
        return
      }
      this.apiGet('/api/shangjia/login/doLogin', this.datas, ret => {
        console.log(ret)
        if (ret.state) {
          localStorage.setItem('loginInfo', ret.data)
          localStorage.setItem('token', ret.data.login_token)
          localStorage.setItem('login', true)
          localStorage.setItem('loginStatus', 1)
          // this.$message(
          //   {
          //     message: '登陆成功',
          //     type: 'success'
          //   }
          // );
          localStorage.setItem('loginStatus', 1)
          setTimeout(res => {
            this.$router.push({ path: '/home' })
          }, 500)
        } else {
          that.$message(ret.msg)
        }
      })
    },
    sigins: function () {
      let that = this
      if (!this.datas.phone) {
        this.$message('请输入账号')
        return
      }
      if (!this.datas.password) {
        this.$message('请输入密码')
        return
      }
      if (!this.datas.business_name) {
        this.$message('请输入商户明')
        return
      }
      this.apiGet('/api/shangjia/login/reg', this.datas, ret => {
        if (ret.state) {
          this.isLogin = true
        } else {
        }
        that.$message(ret.msg)
      })
    }
  }

}



// WEBPACK FOOTER //
// ./src/views/login/login.js